<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="card height-100">
        <header class="header-card">
        <p> {{ $t('societes.venteInterne.title') }} </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-2">
            <b-field :label="$t('societes.venteInterne.activation')">
              <qd-switch v-model="societe.refacturationActive" class="mgt-5px" :disabled="readOnly">
              </qd-switch>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('societes.venteInterne.recopieRemise')">
              <qd-switch v-model="societe.refacturationCopieRemises" class="mgt-5px"
                :disabled="readOnly">
              </qd-switch>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('societes.venteInterne.pourcentage')">
              <input-currency v-model="societe.refacturationPourcentage" isNumber="true"
              :disabled="readOnly">
              </input-currency>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('societes.venteInterne.agence')">
              <b-select expanded v-model="societe.refacturationAgenceId"
                        :disabled="readOnly">
                <option :key="agence.id"
                        :value="agence.id"
                        v-for="agence in societe.agences">
                  {{ agence.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12" v-if="societe.listeSocieteTiers">
            <v-client-table :data="societe.listeSocieteTiers" :columns="columns"
              :options="options">
              <div slot="societe" slot-scope="props">
                 {{ props.row.societe.libelle }}
              </div>
              <div slot="delaiReglement" slot-scope="props" >
                <b-select v-model="props.row.delaiReglementId" :disabled="readOnly"
                  @input="majValue(props.row.id, props.row.delaiReglementId,'delaiReglementId')"
                  expanded>
                  <option :value=null>
                  </option>
                  <option v-for="delai in delaisReglement"
                          :key="delai.id"
                          :value="delai.id">
                    {{delai.libelle}}
                  </option>
                </b-select>
              </div>
              <div slot="modeReglement" slot-scope="props" >
                <b-select expanded v-model="props.row.modeReglementId" :disabled="readOnly"
                 @input="majValue(props.row.id, props.row.modeReglementId,'modeReglementId')">
                <option :value=null>
                </option>
                <option v-for="modeReglement in modesReglement"
                        :key="modeReglement.id"
                        :value="modeReglement.id">
                  {{modeReglement.libelle}}
                </option>
              </b-select>
              </div>
              <div slot="client" slot-scope="props" >
                 <b-autocomplete
                  v-model="props.row.clientNom"
                  :open-on-focus="openOnFocus"
                  :data="dataClients"
                  field="nomCommercial"
                  :disabled="readOnly"
                  @select="tiers => ajouterTiers(tiers, props.row.id, 'client')"
                  @input="getAsyncClientData"
                  :loading="isFetchingClient"
                  :placeholder="$t('ajoutDevis.clients.searchClient')">
                  <template slot-scope="propsTiers">
                    {{ propsTiers.option.nomCommercial }}
                  </template>
                </b-autocomplete>
              </div>
              <div slot="fournisseur" slot-scope="props" >
                 <b-autocomplete
                  v-model="props.row.fournisseurNom"
                  :open-on-focus="openOnFocus"
                  :data="dataClients"
                  field="nomCommercial"
                  :disabled="readOnly"
                  @select="tiers => ajouterTiers(tiers, props.row.id, 'fournisseur')"
                  @input="getAsyncFournisseurData"
                  :loading="isFetchingFournisseur"
                  :placeholder="$t('ajoutDevis.clients.searchClient')">
                  <template slot-scope="propsTiers">
                    {{ propsTiers.option.nomCommercial }}
                  </template>
                </b-autocomplete>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { getAllByTradeName } from '@/api/tiers/index';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import {
  TIERS_TYPE_CLIENT, TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      dataClients: [],
      openOnFocus: false,
      isFetchingClient: false,
      isFetchingFournisseur: false,
    };
  },
  props: {
    societe: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    inputCurrency,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      return [
        'societe',
        'fournisseur',
        'client',
        'delaiReglement',
        'modeReglement',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          societe: this.$i18n.t('societes.venteInterne.tabTiers.societe'),
          fournisseur: this.$i18n.t('societes.venteInterne.tabTiers.fournisseur'),
          client: this.$i18n.t('societes.venteInterne.tabTiers.client'),
          delaiReglement: this.$i18n.t('societes.venteInterne.tabTiers.delaiReglement'),
          modeReglement: this.$i18n.t('societes.venteInterne.tabTiers.modeReglement'),
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          societe: 'vertical-alignment',
        },
      };
    },
    delaisReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.delaiReglement);
    },
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getAsyncClientData: debounce(async function ClientData(search) {
      if (!search) return;
      this.dataClients = [];
      this.isFetchingClient = true;
      try {
        const clients = (await getAllByTradeName(search, this.societe.id, TIERS_TYPE_CLIENT,
          [TIERS_SOUS_TYPE_AUCUN]))
          .data.result.items;
        this.dataClients = clients;
        this.isFetchingClient = false;
      } catch {
        this.isFetchingClient = false;
      }
    }, 500),
    getAsyncFournisseurData: debounce(async function FournisseurData(search) {
      if (!search) return;
      this.dataClients = [];
      this.isFetchingFournisseur = true;
      try {
        const fournisseurs = (await getAllByTradeName(search,
          this.societe.id, TIERS_TYPE_FOURNISSEUR))
          .data.result.items;
        this.dataClients = fournisseurs;
        this.isFetchingFournisseur = false;
      } catch {
        this.isFetchingFournisseur = false;
      }
    }, 500),
    ajouterTiers(tiers, societeTiersId, typeTiers) {
      if (!tiers) return;
      const societeTiers = this.societe.listeSocieteTiers
        .find(st => { return st.id === societeTiersId; });
      societeTiers[typeTiers + 'Id'] = tiers.id;
      societeTiers[typeTiers + 'Nom'] = tiers.nomCommercial;
      societeTiers[typeTiers] = tiers;
      this.dataClients = [];
    },
    majValue(societeTiersId, value, propriete) {
      const societeTiers = this.societe.listeSocieteTiers
        .find(st => { return st.id === societeTiersId; });
      societeTiers[propriete] = value;
    },
  },
  async created() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.societe.listeSocieteTiers.forEach(st => {
        st.clientNom = st.client?.nomCommercial;
        st.fournisseurNom = st.fournisseur?.nomCommercial;
        st.clientNomIsFetching = false;
        st.fournisseurNomIsFetching = false;
      });
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.delaiReglement,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
